// Socket.IO connection lifecycle state per docs/ui/operator-ui-tds.md §5.1.
// The actual Socket.IO singleton client lands with NEX-147; this store is consumed by
// the reconnection-UX banner (NEX-150) and any panel that needs a stale-state indicator.

import { create } from 'zustand';

export interface ConnectionState {
  connected: boolean;
  lastError: string | null;
  reconnectAttempts: number;
  lastUpdateAt: number | null;

  setConnected: (connected: boolean) => void;
  setError: (message: string | null) => void;
  incrementReconnectAttempts: () => void;
  resetReconnectAttempts: () => void;
  markUpdate: () => void;
}

export const useConnectionStore = create<ConnectionState>((set) => ({
  connected: false,
  lastError: null,
  reconnectAttempts: 0,
  lastUpdateAt: null,

  setConnected: (connected) => set(connected ? { connected, lastError: null } : { connected }),
  setError: (lastError) => set({ lastError }),
  incrementReconnectAttempts: () =>
    set((s) => ({ reconnectAttempts: s.reconnectAttempts + 1 })),
  resetReconnectAttempts: () => set({ reconnectAttempts: 0 }),
  markUpdate: () => set({ lastUpdateAt: Date.now() }),
}));
